module.exports = __webpack_public_path__ + "img/web.31bb3272.svg";